import React from 'react'
import {formatInZone, zoneNotice} from 'helpers/datetime'
import {Col, Row, List, Tag, Typography} from 'antd'
import {Spin} from 'antd'
import {useMutation, useQuery} from 'react-query'

import Item from './Item'
import * as flagsQueries from '../../../queries/flags.queries'
import * as Styled from './counterview.styled'
import Link from 'components/SafeLink'

const {Title} = Typography

function FlagView({params}) {
    const flagsQuery = useQuery(['id', params.id], flagsQueries.getFlagsById)

    const flags = flagsQuery.data?.data.data

    /* G40-456: render this record's times on the clock they belong to — the
       order's, supplied by the API, or the operator's when the record has no
       order behind it. `zoneLine` names which, and says when it was inferred. */
    const fmt = (value, options = {}) =>
        formatInZone(value, flags?.order_timezone, options)
    const zoneLine = zoneNotice(
        flags?.order_timezone,
        flags?.order_timezone_source,
    )
    if (flagsQuery.isLoading) {
        return (
            <Styled.Root>
                <Spin />
            </Styled.Root>
        )
    }

    return (
        <>
            {/* G40-456 zone caption — say whose clock these times are on */}
            <div
                style={{
                    fontSize: '85%',
                    opacity: 0.75,
                    margin: '0 0 10px 8px',
                }}>
                {zoneLine}
            </div>
            <div className="order">
                <Col className="order_col">
                    <List
                        size="small"
                        bordered
                        style={{
                            background: 'rgba(0,0,0,0.03)',
                            paddingTop: '1.05rem',
                        }}
                        header={<Title level={5}>Basic Info</Title>}>
                        <Item
                            body={
                                <Link to={`/flags/${flags.id}`}>
                                    {flags.id}
                                </Link>
                            }
                            title="Id "
                        />
                        <Item
                            body={
                                <Link to={`/booking/${flags.order_id}`}>
                                    {flags.order_id}
                                </Link>
                            }
                            title="Order Id"
                        />
                        <Item
                            body={
                                <Link to={`/user/${flags.order_id}`}>
                                    {flags.title}
                                </Link>
                            }
                            title="Order Title"
                        />
                        <Item
                            body={
                                <Link to={`/user/${flags.user_id}`}>
                                    {flags.user_id}
                                </Link>
                            }
                            title="User Id"
                        />
                    </List>
                </Col>
                <Col className="order_col">
                    <List
                        size="small"
                        bordered
                        style={{background: 'rgba(0,0,0,0.03)'}}>
                        <Item
                            body={
                                <Link to={`/user/${flags.user_id}`}>
                                    {flags.user_name}
                                </Link>
                            }
                            title="User Title"
                        />
                        <Item
                            body={flags.description || 'N/A'}
                            title="Description"
                        />

                        <Item
                            body={
                                fmt(flags.created_at, {withParens: true}) ||
                                'N/A'
                            }
                            title="Created On"
                        />

                        <Item
                            body={
                                fmt(flags.updated_at, {withParens: true}) ||
                                'N/A'
                            }
                            title="Updated On"
                        />
                    </List>
                </Col>
            </div>
        </>
    )
}

export default FlagView
